import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import { ApiService } from '../../../services/api.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { VisitVehicle } from '../models/visit-vehicle.entity';

/**
 * Base url for api
 */
const BASE_URL = 'visit-vehicles';

@Injectable({
  providedIn: 'root'
})

/**
 * Visit Vehicle Service
 */
export class VisitVehicleService {

  /**
   * Is loading
   */
  public loading$: Observable<boolean>;

  /**
   * Constructor
   *
   * @param apiService ApiService
   * @param httpClient HttpClient
   * @param authenticationService AuthenticationService
   */
  constructor(private apiService: ApiService, private  httpClient: HttpClient, private authenticationService: AuthenticationService) {
    this.loading$ = this.apiService.loading$;
  }
  /**
   * Create
   *
   * @param visitVehicle VisitVehicle instance
   */
  create(visitVehicle: VisitVehicle): Observable<any> {
    console.log(JSON.stringify(visitVehicle));
    return this.apiService.post(BASE_URL, visitVehicle);
  }

  /**
   * Update
   * @param  visitVehicle VisitVehicle instance
   */
  update(visitVehicle: VisitVehicle): Observable<any> {
    const visitVehicleId = visitVehicle.visitId;
    delete visitVehicle.visitId;
    return this.apiService.patch(`${BASE_URL}/${visitVehicleId}`, visitVehicle);
  }

  /**
   * Delete
   *
   * @param id Primary key
   */
  delete(id: number): Observable<any> {
    return this.apiService.delete(`${BASE_URL}/${id}`);
  }

  /**
   * Find filtered
   *
   * @param queryOptions Object with query options
   */
  findFiltered(queryOptions): Observable<VisitVehicle[]> {
    return this.apiService.post(`${BASE_URL}/list`, queryOptions).pipe(map(
      visitVehicles => visitVehicles.map(
        (visitVehicle) => VisitVehicle.createFromJson(visitVehicle))
      )
    );
  }

  /**
   * Get count for filter
   *
   * @param order Order
   * @param sort Sort
   * @param limit Limit
   * @param page Page
   * @param filter Filter object
   */
  // tslint:disable-next-line:max-line-length
  getCount(order: string = 'visitId', sort: string = 'desc', limit: number = 10, page: number = 0, filter: object = {}): Observable<object> {
    const options = {order, sort, limit, page};
    for (const i in filter) {
      if (filter.hasOwnProperty(i) && filter[i] === '') {
        delete filter[i];
      }
    }
    return this.apiService.post(`${BASE_URL}/count`, {...options, ...filter});
  }

}
